export enum AuthTypes {
	USER_NAME = 'USER_NAME/PWD',
	EMAIL = 'EMAIL/PWD',
	FACEBOOK = 'FACEBOOK',
	GOOGLE = 'GOOGLE',
	TWITTER = 'TWITTER',
	LINKEDIN = 'LINKEDIN',
}
